import { useModal } from "../../hooks/use-modal.jsx";
import TenantAddForm from "../../components/Tenant/Forms/TenantAddForm";

export default function TenantAddPage() {
  const [TenantAddModal] = useModal(true);

  return <TenantAddForm modal={TenantAddModal} />;
}
